import {Injectable} from '@angular/core';
import {DataCoreService, DlistDto, environment as env, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import {BehaviorSubject, catchError, finalize, tap, throwError} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class TebEkonomikService {
  public period!: number;
  public piHesapTuru!: number;
  public harcamaKodu: number | null = null;
  private _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();

  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {
  }


  setParams(period: number, piHesapTuru: number, harcamaKodu: number) {
    this.period = period;
    this.piHesapTuru = piHesapTuru;
    this.harcamaKodu = harcamaKodu;
  }

  getDlist(formName: string): any {
    const request = new GetDlist_Request({
      dListCode: formName
    })
    this._httpClient.post<GetDlist_Response>(`${env.lookupService}/System/GetDList`, request).pipe(
      tap(response => {
        this._gridControlsList.next(response.dListMetadata)
      }),
      catchError(err => throwError(err)),
      finalize(() => {
      })
    ).subscribe();
  }

  getData(code: string, period: number, piHesapTuru: number, harcamaKodu: number, isSetData?: boolean) {
    if (piHesapTuru === 1) {
      const dataSource = this.dataCoreService.getOData('TebGelir');
      dataSource.select(['Kod', 'Ad', 'Donem', 'EkoGelirKod']);
      const filterArr = [];
      if (period) filterArr.push(['Donem', '=', period]);
      if (code) filterArr.push(['EkoGelirKod', '=', code]);
      filterArr.push(['EkoGelirKod.Length', '>=', 6]);
      dataSource.filter(filterArr);
      return dataSource;
    } else if (harcamaKodu === null && piHesapTuru === 2) {
      const dataSource = this.dataCoreService.getOData('TebGider');
      dataSource.select(['Kod', 'Ad', 'Donem', 'EkoGiderKod']);
      const filterArr = [];
      if (period) filterArr.push(['Donem', '=', period]);
      if (code) filterArr.push(['EkoGiderKod', '=', code]);
      filterArr.push(['EkoGiderKod.Length', '>=', 6]);
      dataSource.filter(filterArr);
      return dataSource;
    } else return null;
  }
}
